import DATA from '../../plugins/DATA' 
import DB from '../../plugins/DB' 
import  { 
  toDateTime, 
  toDate,
  toTime,
  TEXT_UP,
  TEXT_UP1,
  TEXT_UP11,
  TEXT_UP0,
  TEXT_EQ,
  TEXT_SPLIT_N,
  TEXT_SPACE0,
  SIZE, 
} from '../../plugins/MBS_actions' 
import formatNumber  from '../../plugins/formatNumber'   
import moment from 'moment'   
let NAME = "JOINED" 

const toNumber=formatNumber.toNumber
const toMoney=formatNumber.toMoney
const toSameLength=formatNumber.toSameLength

export default{
    state: { 
      JOINING:[],  

      ERRORS:null, 
      MESSAGES:null, 
      NOTIFICATIONS:null,
      SERVICES:null, 
      ID_TYPES:null, 
      OCCURRENCES:null, 
      REPORTERS:null, 
      REPORTER_CATEGORIES:null, 
      WEB_REPORTS:null, 
      WHATSAPP_REPORTS:null, 
      MOBILE_REPORTS:null, 
      SMS_REPORTS:null, 
      PERSONAL_REPORTS:null, 
      
      COUNTRIES:null,  
      REGIONS:null,  
      DISTRICTS:null, 
      CONSTITUENCIES:null, 
      WARDS:null, 
      CENTRES:null, 
      TRADITION_AUTHORITIES:null, 

      QUESTION_TYPES:null, 
      QUESTION_CATEGORIES:null, 
      QUESTION_TIMELINES:null, 
      QUESTION_STAGES:null, 
      QUESTIONNAIRES:null, 
 
    },
    //___________________-GETTERS-_________________
    getters: { 
      isJoining(state) { 
        return name=>{
          if (SIZE(state.JOINING)==0){return false}
          let join = state.JOINING.find(item=>{
            return TEXT_UP(item.name) == [TEXT_UP(name)]
          })
          return join?join.loading:false
        }
      }, 
      getJoined(state) { 
        return name=>{
          if (SIZE(state.JOINING)==0){return null}
          let joins = state.JOINING.find(join=>{
            return TEXT_UP(join.name) == [TEXT_UP(name)]
          })
          return joins
        }
      },    
      getAllJoinedItems(state) { 
        return state[TEXT_UP("ALL_"+DATA.ITEMS.ITEMS.values)]
      }, 
      getJoinState(state) { 
        return state
      }, 
    },
    //___________________-MUTATIONS-___________________
    mutations:{  
      setJoining(state, payload) {
        let name = payload?payload.name:null
        let loading = payload?payload.loading:null
        let response = payload?payload.response:null
        if(!name){return}
        if (!state.JOINING) {
          state.JOINING = []
        }
        let joining_item = state.JOINING.find(item=>{
          return item.name == name
        })
        if (joining_item) {
          joining_item.loading = loading
          joining_item.response = response
        }else{
          state.JOINING.push({
            name:name,
            loading:loading,
            response:response,
          })
        } 
      },   
      setJoinedItems(state, payload) {
        try {
          let name = payload?payload.name:null
          let data = payload?payload.data:null
          state[name] = data  
        } catch (error) {
          console.log(error);
        }
      }, 
      updateJoinedItemsByKey(state, payload) {
        try {
          let name = payload?payload.name:null
          let data = payload?payload.data:null
          let stateData =[]
          if (state[name]) {stateData = [...state[name] ]}  
          if (data) {  
            for (const element of data) {
              var foundIndex = stateData.findIndex(x => x.key == element.key); 
              if(foundIndex != -1) { 
                stateData[foundIndex] = element;
              }else{
                stateData.push(element)
              } 
            }  
            state[name]=stateData
          }
        } catch (error) {
          console.log(error);
        }
      }, 
    },
    //____________________-ACTIONS-_____________________
    actions: { 
      //-------------[JOIN]---------------
      join({ commit,dispatch},payload) {
        let response = {
          from:'join',
          page:NAME, 
          payload:payload
        }
        let item_name = null
        let processed_data = null
        return new Promise(async(resolve,reject)=>{
          try { 
            let name = payload?payload.name:null  
            let data = payload?payload.data:null  
            let add = payload?payload.add:null  
            let isUpdates = payload?payload.isUpdates:null  
            let join_commit_action = null 
            
            if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.USERS.values)) {
              join_commit_action = "join_user"
              item_name = DATA.ITEMS.USERS.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.ITEMS.values)) {
              join_commit_action = "join_item"
              item_name = DATA.ITEMS.ITEMS.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.REPORTERS.values)) {
              join_commit_action = "join_reporters"
              item_name = DATA.ITEMS.REPORTERS.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.COUNTRIES.values)) {
              join_commit_action = "join_countries"
              item_name = DATA.ITEMS.COUNTRIES.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.REGIONS.values)) {
              join_commit_action = "join_regions"
              item_name = DATA.ITEMS.REGIONS.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.DISTRICTS.values)) {
              join_commit_action = "join_districts"
              item_name = DATA.ITEMS.DISTRICTS.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.CONSTITUENCIES.values)) {
              join_commit_action = "join_constituencies"
              item_name = DATA.ITEMS.CONSTITUENCIES.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.WARDS.values)) {
              join_commit_action = "join_wards"
              item_name = DATA.ITEMS.WARDS.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.CENTRES.values)) {
              join_commit_action = "join_centres"
              item_name = DATA.ITEMS.CENTRES.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.TRADITION_AUTHORITIES.values)) {
              join_commit_action = "join_tradition_authorities"
              item_name = DATA.ITEMS.TRADITION_AUTHORITIES.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.QUESTIONNAIRES.values)) {
              join_commit_action = "join_questionnaires"
              item_name = DATA.ITEMS.QUESTIONNAIRES.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.MOBILE_REPORTS.values)) {
              join_commit_action = "join_mobile_reports"
              item_name = DATA.ITEMS.MOBILE_REPORTS.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.WEB_REPORTS.values)) {
              join_commit_action = "join_web_reports"
              item_name = DATA.ITEMS.WEB_REPORTS.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.SMS_REPORTS.values)) {
              join_commit_action = "join_sms_reports"
              item_name = DATA.ITEMS.SMS_REPORTS.values
            }else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.PERSONAL_REPORTS.values)) {
              join_commit_action = "join_person_reports"
              item_name = DATA.ITEMS.PERSONAL_REPORTS.values
            } else if (TEXT_UP(name)===TEXT_UP("ALL_"+DATA.ITEMS.OCCURRENCES.values)) {
              join_commit_action = "join_occurrences"
              item_name = DATA.ITEMS.OCCURRENCES.values
            } 
            else if (name) {
              let index = TEXT_UP(name).indexOf("ALL_") 
              if (index == 0) {  
                join_commit_action = "join_others"
                item_name = name.slice(4) 
              } 
            }   
            commit("setJoining",{name:item_name,loading:true}) 
            setTimeout(async() => {
              if (join_commit_action) { 
                let isArray = Array.isArray(data) 
                if (isArray) {
                  let joined_items = []
                  let all_joined_items = []
                  let archived_joined_items = []
                  let NUMBER = 0 
                  for (const element of data) {
                    NUMBER = NUMBER+1  
                    let res = await dispatch(join_commit_action,{
                      name:name,
                      data:element,
                      add:add,
                      NUMBER:NUMBER,
                    })
                    let res_data = res?res.data:null 
                    if (res_data) { 
                      all_joined_items.push(res_data)  
                      if (res_data.archive) {
                        archived_joined_items.push(res_data)
                      }else{
                        joined_items.push(res_data)
                      }
                    }  
                  } 
                   
                  //save
                  if (add) { 
                    if (isUpdates) {
                      commit("updateJoinedItemsByKey",{
                        name:TEXT_UP(item_name),
                        data:joined_items,
                      })
                      commit("updateJoinedItemsByKey",{
                        name:TEXT_UP("all_"+item_name),
                        data:all_joined_items,
                      })
                      commit("updateJoinedItemsByKey",{
                        name:TEXT_UP("archived_"+item_name),
                        data:archived_joined_items,
                      })  
                    } else { 
                      commit("setJoinedItems",{
                        name:TEXT_UP(item_name),
                        data:joined_items,
                      })
                      commit("setJoinedItems",{
                        name:TEXT_UP("all_"+item_name),
                        data:all_joined_items,
                      })
                      commit("setJoinedItems",{
                        name:TEXT_UP("archived_"+item_name),
                        data:archived_joined_items,
                      }) 
                    }
                  }
                  processed_data = {
                    joined:joined_items,
                    all_joined:all_joined_items,
                    archived_joined:archived_joined_items,
                  } 
                } else {
                  let res = await dispatch(join_commit_action,{
                    name:item_name,
                    data:data,
                    add:add 
                  })
                  processed_data = res?res.data:null
                }   
                response = {
                  success:true, 
                  data:processed_data,
                  is_array:isArray,
                  isArray:isArray,
                }
                commit("setJoining",{name:item_name,loading:false,response:response})
                resolve(response) 
              } else {
                response = {
                  ...response,
                  success:false,
                  error:'action not found', 
                }
                commit("setJoining",{name:item_name,loading:false,response:response})
                reject(response)
              }  
            }, 1); 
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            commit("setJoining",{name:item_name,loading:false,response:response})
            reject(response)  
          }  
        })
      },
      join_user({ commit,getters},payload) {
        let response = {
          from:'join_user',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try { 
            let name = payload?payload.name:null  
            let element = payload?payload.data:null  
            let add = payload?payload.add:null  
            let NUMBER = payload?payload.NUMBER:1   
            if(element){
              let uid = element.key
              let email = element.email
              if (!email) {
                  let user = getters.getUserByUid(uid)
                  if (user) {
                      element = {
                          ...user,
                          element,
                      } 
                  }
              }
              //find districts
              let user_group_code = element.user_group_code 
              let user_group = getters.getUserGroupByCode(user_group_code)
              let user_group_name = user_group?user_group.name:'...'
              let active_status = element.disabled?'Disabled':'Active'
              active_status = element.reset_password?'Rest Password':active_status
              let user_status = getters.getUserStatusByKey(uid)

              let selectedCompany = getters.getSelectedCompany
              let company_key = selectedCompany?selectedCompany.key:null
              let companies = element.companies
              let company  = companies && company_key?companies[company_key]:null
              let company_user_group_code = company?company.company_user_group_code:null
              let company_user_group = getters.getCompanyUserGroupByCode(company_user_group_code)
              let company_user_group_name = company_user_group?company_user_group.name:'...'
      
              let newData = {
                  ...element,
                  no:NUMBER,  
                  user_group:user_group,
                  user_group_name:user_group_name, 
                  reg_status:element.registered?'Registered':element.signup_status,
                  active_status:active_status,
                  user_status:user_status,
                  company:company,
                  company_key:company_key,
                  company_user_group:company_user_group,
                  company_user_group_name:company_user_group_name,
                  name:TEXT_UP11(element.surname+' '+element.names),
                  last_changed:user_status?user_status.last_changed:null,
                  logged:user_status?user_status.logged:null,
                  online:user_status?user_status.online:null,
                  last_changed_:user_status? toDateTime(user_status.last_changed):'', 
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 

              } 
              resolve({
                success:true, 
                data:newData
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            } 

             
            
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_item({ commit,getters},payload) {
        let response = {
          from:'join_item',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){
              let item_code = element.item_code 
              let item_key = element.item_key
              if (item_key) { 
                  let item = getters.getItemByKey(item_key)
                  if (item) {
                      element={
                          ...item,
                          ...element,
                      }
                  }
              }else if (item_code) { 
                  let item = getters.getItemByKey(item_code)
                  if (item) {
                      element={
                          ...item,
                          ...element,
                      }
                  }
              }  
              //category
              // fixing old version 0.0.28
              if (!element.category_code && element.item_category_code) {
                  element.category_code = element.item_category_code
              }
              let category_code = element.category_code 
              let item_category = getters.getItemCategoryByCode(category_code)
              let category_name = item_category?item_category.name:'--'
              
              //brand
              let brand_code = element.brand_code
              let brand = getters.getBrandByCode(brand_code)
              let brand_name = brand?brand.name:'--'
              //manufacturers
              let manufacturer_code = element.manufacturer_code
              let manufacturer = getters.getManufacturerByCode(manufacturer_code)
              let manufacturer_name = manufacturer?manufacturer.name:'--'
              
              //Tax
              let tax_group_code = element.tax_group_code
              let tax_group = getters.getTaxGroupByCode(tax_group_code)
              let tax_group_name = tax_group?tax_group.name:'--'
              
              //supplier
              let supplier_code = element.supplier_code
              let supplier = getters.getSupplierByCode(supplier_code)  

              // number
              let number_sales = toNumber(element.number_sales?element.number_sales:0)
              let number_returned_sales = toNumber(element.number_returned_sales?element.number_returned_sales:0)
              let number_stock_receives = toNumber(element.number_stock_receives?element.number_stock_receives:0)
              let number_stocks_return = toNumber(element.number_stocks_return?element.number_stocks_return:0)
              let number_stock_adjustments = toNumber(element.number_stock_adjustments?element.number_stock_adjustments:0)
              let number_stock_transfer = toNumber(element.number_stock_transfer?element.number_stock_transfer:0)
              let number_opening_stocks = toNumber(element.number_opening_stocks?element.number_opening_stocks:0)

              let opening_stock = toNumber(element.opening_stock)

              //calculate cost
              let number_average_cost = toNumber(element.number_average_cost?element.number_average_cost:0)
              let cost_price = toNumber(element.cost_price)
              if (number_average_cost===0) {
                number_average_cost = cost_price
              }


              
              let number_quantity = number_stock_receives
                +opening_stock
                +number_opening_stocks
                -number_stocks_return
                -number_sales
                +number_returned_sales
                +number_stock_adjustments
              let index = (""+number_quantity).indexOf(".")
              if (index !=-1) {
                number_quantity=number_quantity.toFixed(3)
              }

              let number_total_cost = cost_price*number_quantity 
              // number_average_cost = number_total_cost==0?0:number_average_cost
      
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  tax_:element.tax?"Yes":"No", 
                  item_category:item_category,
                  category_name:category_name, 
                  brand:brand,
                  brand_name:brand_name, 
                  manufacturer:manufacturer,
                  manufacturer_name:manufacturer_name, 
                  supplier:supplier,  
                  tax_group_code:tax_group_code,  
                  tax_group:tax_group,   
                  tax_group_name:tax_group_name,   
                  number_quantity:number_quantity,
                  
                  number_average_cost:number_average_cost,
                  number_average_cost_:toMoney(number_average_cost),
                  number_total_cost:number_total_cost,
                  number_total_cost_:toMoney(number_total_cost),
                  cost_price_:toMoney(element.cost_price),
  
                  retail_price_:toMoney(element.retail_price), 
                  wholesale_price_:toMoney(element.wholesale_price),  
                  code_:toSameLength(element.code),
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              }  
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_reporters({ commit,getters},payload) {
        let response = {
          from:'join_reporters',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){
              let reporter_category_code = element.reporter_category_code
              let reporter_category = getters.getReporterCategoryByCode(reporter_category_code)
              let reporter_category_name = reporter_category?reporter_category.name:'--'
                  
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  reporter_category:reporter_category,
                  reporter_category_name:reporter_category_name, 
                  name:TEXT_UP11(element.name),
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_countries({ commit,getters},payload) {
        let response = {
          from:'join_countries',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){ 
                  
              let newItem = {
                  ...element,
                  no:NUMBER,  
                  name:TEXT_UP11(element.name),
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      }, 
      join_regions({ commit,getters},payload) {
        let response = {
          from:'join_regions',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){
              let country_code = element.country_code
              let country = getters.getCountryByCode(country_code)
              let country_name = country?country.name:'--'
                  
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  country:country,
                  country_name:country_name, 
                  name:TEXT_UP11(element.name),
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_districts({ commit,getters},payload) {
        let response = {
          from:'join_districts',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){

              //get region
              let region_code = element.region_code
              let region = getters.getRegionByCode(region_code)
              let region_name = region?region.name:'--'
              //get Country 
              let country_code = region?region.country_code:null
              let country = getters.getCountryByCode(country_code)
              let country_name = country?country.name:'--'
                  
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  region:region,
                  region_name:region_name, 
                  country:country,
                  country_name:country_name, 
                  country_code:country_code, 
                  name:TEXT_UP11(element.name),
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_constituencies({ commit,getters},payload) {
        let response = {
          from:'join_constituencies',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){

              //get district
              let district_code = element.district_code
              let district = getters.getDistrictByCode(district_code)
              let district_name = district?district.name:'--'
              //get region
              let region_code = district?district.region_code:null
              let region = getters.getRegionByCode(region_code)
              let region_name = region?region.name:'--'
              //get Country 
              let country_code = region?region.country_code:null
              let country = getters.getCountryByCode(country_code)
              let country_name = country?country.name:'--'
                  
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  district:district,
                  district_name:district_name, 
                  region:region,
                  region_name:region_name, 
                  region_code:region_code, 
                  country:country,
                  country_name:country_name, 
                  country_code:country_code, 
                  name:TEXT_UP11(element.name),
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_wards({ commit,getters},payload) {
        let response = {
          from:'join_wards',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){

              //get ward
              let constituency_code = element.constituency_code
              let constituency = getters.getConstituencyByCode(constituency_code)
              let constituency_name = constituency?constituency.name:'--'
              //get district
              let district_code = constituency?constituency.district_code:null
              let district = getters.getDistrictByCode(district_code)
              let district_name = district?district.name:'--'
              //get region
              let region_code = district?district.region_code:null
              let region = getters.getRegionByCode(region_code)
              let region_name = region?region.name:'--'
              //get Country 
              let country_code = region?region.country_code:null
              let country = getters.getCountryByCode(country_code)
              let country_name = country?country.name:'--'
                  
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  constituency:constituency,
                  constituency_name:constituency_name, 
                  district:district,
                  district_name:district_name, 
                  district_code:district_code, 
                  region:region,
                  region_name:region_name, 
                  region_code:region_code, 
                  country:country,
                  country_name:country_name, 
                  country_code:country_code, 
                  name:TEXT_UP11(element.name),
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_centres({ commit,getters},payload) {
        let response = {
          from:'join_centres',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){

              //get ward
              let ward_code = element.ward_code
              let ward = getters.getWardByCode(ward_code)
              let ward_name = ward?ward.name:'--'
              //get constituency
              let constituency_code = ward?ward.constituency_code:null
              let constituency = getters.getConstituencyByCode(constituency_code)
              let constituency_name = constituency?constituency.name:'--'
              //get district
              let district_code = constituency?constituency.district_code:null
              let district = getters.getDistrictByCode(district_code)
              let district_name = district?district.name:'--'
              //get region
              let region_code = district?district.region_code:null
              let region = getters.getRegionByCode(region_code)
              let region_name = region?region.name:'--'
              //get Country 
              let country_code = region?region.country_code:null
              let country = getters.getCountryByCode(country_code)
              let country_name = country?country.name:'--'
                  
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  // code_:toNumber(element.code), 
                  ward:ward,
                  ward_name:ward_name, 
                  constituency:constituency,
                  constituency_name:constituency_name, 
                  constituency_code:constituency_code, 
                  district:district,
                  district_name:district_name, 
                  district_code:district_code, 
                  region:region,
                  region_name:region_name, 
                  region_code:region_code, 
                  country:country,
                  country_name:country_name, 
                  country_code:country_code, 
                  name:TEXT_UP11(element.name),
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_tradition_authorities({ commit,getters},payload) {
        let response = {
          from:'join_tradition_authorities',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){

              
              //get district
              let district_code = element?element.district_code:null
              let district = getters.getDistrictByCode(district_code)
              let district_name = district?district.name:'--'
              //get region
              let region_code = district?district.region_code:null
              let region = getters.getRegionByCode(region_code)
              let region_name = region?region.name:'--'
              //get Country 
              let country_code = region?region.country_code:null
              let country = getters.getCountryByCode(country_code)
              let country_name = country?country.name:'--'
                  
              let newItem = {
                  ...element,
                  no:NUMBER,  
                  district:district,
                  district_name:district_name, 
                  district_code:district_code, 
                  region:region,
                  region_name:region_name, 
                  region_code:region_code, 
                  country:country,
                  country_name:country_name, 
                  country_code:country_code, 
                  name:TEXT_UP11(element.name),
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_questionnaires({ commit,getters},payload) {
        let response = {
          from:'join_questionnaires',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){

              //get category
              let question_category_code = element.question_category_code
              let question_category = getters.getQuestionCategoryByCode(question_category_code)
              let question_category_name = question_category?question_category.name:'--'
              
              //get type
              let question_type_code = element.question_type_code
              let question_type = getters.getQuestionTypeByCode(question_type_code)
              let question_type_name = question_type?question_type.name:'--'
              
              //get stage
              let question_stage_code = element.question_stage_code
              let question_stage = getters.getQuestionStageByCode(question_stage_code)
              let question_stage_name = question_stage?question_stage.name:'--'
              
              //get timeline
              let question_timeline_code = element.question_timeline_code
              let question_timeline = getters.getQuestionTimelineByCode(question_timeline_code)
              let question_timeline_name = question_timeline?question_timeline.name:'--'
              
              //get occurrence
              let occurrence_code = element.occurrence_code
              let occurrence = getters.getOccurrenceByCode(occurrence_code)
              let occurrence_name = occurrence?occurrence.name:'--'
               
                  
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  question_category:question_category,
                  question_category_name:question_category_name, 
                  question_type:question_type,
                  question_type_name:question_type_name,   
                  question_stage:question_stage,
                  question_stage_name:question_stage_name,  
                  question_timeline:question_timeline,
                  question_timeline_name:question_timeline_name,  
                  occurrence:occurrence,
                  occurrence_name:occurrence_name,  

                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_mobile_reports({ commit,getters},payload) {
        let response = {
          from:'join_mobile_reports',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){
              let region_code = element.region_code
              let region = getters.getRegionByCode(region_code)
              let region_name = region?region.name:'--'
              
              let district_code = element.district_code
              let district = getters.getDistrictByCode(district_code)
              let district_name = district?district.name:'--'
              
              let constituency_code = element.constituency_code
              let constituency = getters.getConstituencyByCode(constituency_code)
              let constituency_name = constituency?constituency.name:'--'
              
              let ward_code = element.ward_code
              let ward = getters.getWardByCode(ward_code)
              let ward_name = ward?ward.name:'--'

              let centre_code = element.centre_code
              let centre = getters.getCentreByCode(centre_code)
              let centre_name = centre?centre.name:'--'
              
              let question_code = element.question_code
              let question= getters.getQuestionnaireByCode(question_code)
              let question_body = question?question.question_body:'--'
              let question_number = question?question.question_number:'--'
              let question_tag = question?question.question_tag:null
              let question_tag_value = question?question.question_tag_value:null 
              let question_predefined_answer = question?question.question_predefined_answer:null
              
              let reporter_code = element.observer_code
              let reporter= getters.getReporterByCode(reporter_code)      
              let reporter_name = reporter?reporter.first_name+' '+reporter.last_name:'--' 
              
              let question_category_code = element.question_category_code
              let question_category= getters.getQuestionCategoryByCode(question_category_code)      
              let question_category_name = question_category?question_category.name:' ' 
              
              let question_type_code = element.question_type_code
              question_type_code = question_type_code?question_type_code:question?question.question_type_code:null 
              let question_type= getters.getQuestionTypeByCode(question_type_code)      
              let question_type_name = question_type?question_type.name:' ' 
              
              let question_timeline_code = element.question_timeline_code
              let question_timeline= getters.getQuestionTimelineByCode(question_timeline_code)      
              let question_timeline_name = question_timeline?question_timeline.name:' ' 
              
              //occurrence
              let occurrence_code = element.occurrence_code
              if (!occurrence_code) {
                occurrence_code = question?question.occurrence_code:null
              }
              let occurrence = getters.getOccurrenceByCode(occurrence_code)
              let occurrence_name = occurrence?occurrence.name:"--"

              let question_answer_only = "--"
              let question_answer_explanation = "--"
              if (element.question_answer && question_number) {
              
                let indexAnswer = element.question_answer.indexOf(question_number)
                if (indexAnswer!=-1) {
                  question_answer_only = element.question_answer.split(question_number)[1] 
                } 
                if (question_answer_only) {
                  let indexExplanation = question_answer_only.indexOf("#")
                  if (indexExplanation!=-1) {
                    let all = question_answer_only.split("#")
                    question_answer_only = all[0]
                    question_answer_explanation = all[1]
                    
                  }
                  
                }
              }

                  
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  region:region,
                  region_name:region_name, 
                  district:district,
                  district_name:district_name, 
                  constituency:constituency,
                  constituency_name:constituency_name, 
                  ward:ward,
                  ward_name:ward_name, 
                  centre:centre,
                  centre_name:centre_name,  

                  question:question,  
                  question_number:question_number,  
                  question_body:question_body,  
                  question_answer_only:question_answer_only,  
                  question_tag:question_tag,  
                  question_tag_value:question_tag_value,  
                  question_predefined_answer:question_predefined_answer,  

                  reporter:reporter,  
                  reporter_code:reporter_code,  
                  reporter_name:reporter_name,  
                  question_category:question_category,  
                  question_category_name:question_category_name,  
                  question_type:question_type,  
                  question_type_name:question_type_name,  
                  question_timeline:question_timeline,  
                  question_timeline_name:question_timeline_name,  
                  occurrence:occurrence,  
                  occurrence_name:occurrence_name,  
                  occurrence_code:occurrence_code,  
                  question_answer_explanation:question_answer_explanation,  
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_web_reports({ commit,getters},payload) {
        let response = {
          from:'join_web_reports',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){
              let region_code = element.region_code
              let region = getters.getRegionByCode(region_code)
              let region_name = region?region.name:'--'
              
              let district_code = element.district_code
              let district = getters.getDistrictByCode(district_code)
              let district_name = district?district.name:'--'
              
              let constituency_code = element.constituency_code
              let constituency = getters.getConstituencyByCode(constituency_code)
              let constituency_name = constituency?constituency.name:'--'
              
              let ward_code = element.ward_code
              let ward = getters.getWardByCode(ward_code)
              let ward_name = ward?ward.name:'--'

              let centre_code = element.centre_code
              let centre = getters.getCentreByCode(centre_code)
              let centre_name = centre?centre.name:'--'
              
              let question_code = element.question_code
              let question= getters.getQuestionnaireByCode(question_code)
              let question_body = question?question.question_body:'--'
              let question_number = question?question.question_number:'--'
              let question_tag = question?question.question_tag:null
              let question_tag_value = question?question.question_tag_value:null 
              let question_predefined_answer = question?question.question_predefined_answer:null
              
              let reporter_code = element.observer_code
              let reporter_key = null
              let reporter= getters.getReporterByCode(reporter_code)     
              if (!reporter_code) {
                reporter_key = element.updated_uid
                reporter= getters.getUserByUid(reporter_key) 
                if (reporter){
                  reporter.first_name = reporter.names
                  reporter.last_name = ''
                }
              } 
              let reporter_name = reporter?reporter.first_name+' '+reporter.last_name:'--' 
              
              let question_category_code = element.question_category_code
              let question_category= getters.getQuestionCategoryByCode(question_category_code)      
              let question_category_name = question_category?question_category.name:' ' 
              
              let question_type_code = element.question_type_code
              question_type_code = question_type_code?question_type_code:question?question.question_type_code:null 
              let question_type= getters.getQuestionTypeByCode(question_type_code)      
              let question_type_name = question_type?question_type.name:' ' 
              
              let question_timeline_code = element.question_timeline_code
              let question_timeline= getters.getQuestionTimelineByCode(question_timeline_code)      
              let question_timeline_name = question_timeline?question_timeline.name:' ' 
              
              //occurrence
              let occurrence_code = element.occurrence_code
              if (!occurrence_code) {
                occurrence_code = question?question.occurrence_code:null
              }
              let occurrence = getters.getOccurrenceByCode(occurrence_code)
              let occurrence_name = occurrence?occurrence.name:"--"

              let question_answer_only = "--"
              let question_answer_explanation = "--"
              if (element.question_answer && question_number) {
              
                let indexAnswer = element.question_answer.indexOf(question_number)
                if (indexAnswer!=-1) {
                  question_answer_only = element.question_answer.split(question_number)[1] 
                } 
                if (question_answer_only) {
                  let indexExplanation = question_answer_only.indexOf("#")
                  if (indexExplanation!=-1) {
                    let all = question_answer_only.split("#")
                    question_answer_only = all[0]
                    question_answer_explanation = all[1]
                    
                  }
                  
                }
              }

                  
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  region:region,
                  region_name:region_name, 
                  district:district,
                  district_name:district_name, 
                  constituency:constituency,
                  constituency_name:constituency_name, 
                  ward:ward,
                  ward_name:ward_name, 
                  centre:centre,
                  centre_name:centre_name,  

                  question:question,  
                  question_number:question_number,  
                  question_body:question_body,  
                  question_answer_only:question_answer_only,  
                  question_tag:question_tag,  
                  question_tag_value:question_tag_value,  
                  question_predefined_answer:question_predefined_answer,  

                  reporter:reporter,  
                  reporter_code:reporter_code,  
                  reporter_name:reporter_name,  
                  question_category:question_category,  
                  question_category_name:question_category_name,  
                  question_type:question_type,  
                  question_type_name:question_type_name,  
                  question_timeline:question_timeline,  
                  question_timeline_name:question_timeline_name,  
                  occurrence:occurrence,  
                  occurrence_name:occurrence_name,  
                  occurrence_code:occurrence_code,  
                  question_answer_explanation:question_answer_explanation,  
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_sms_reports({ commit,getters},payload) {
        let response = {
          from:'join_sms_reports',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){
              let sent_timestamp = element.sent_timestamp/1000
              let newDate = (ts,format)=>{
                if(!ts){return null}
                let ts_ms = ts * 1000;
                // initialize new Date object
                let date_ob = new Date(ts_ms);
                // year as 4 digits (YYYY)
                let year = date_ob.getFullYear(); 
                // month as 2 digits (MM)
                let month = ("0" + (date_ob.getMonth() + 1)).slice(-2); 
                // date as 2 digits (DD)
                let date = ("0" + date_ob.getDate()).slice(-2); 
                // hours as 2 digits (hh)
                let hours = ("0" + date_ob.getHours()).slice(-2); 
                // minutes as 2 digits (mm)
                let minutes = ("0" + date_ob.getMinutes()).slice(-2); 
                // seconds as 2 digits (ss)
                let seconds = ("0" + date_ob.getSeconds()).slice(-2);
  
                return date + "/" + month + "/" + year + " " + hours + ":" + minutes 
              }
                  
              let newItem = {
                  ...element,
                  no:NUMBER,  
                  sent_at_:newDate(sent_timestamp), 
                  sent_at_date:toDate(sent_timestamp), 
                  sent_at_time:toTime(sent_timestamp), 
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_person_reports({ commit,getters},payload) {
        let response = {
          from:'join_person_reports',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){
              let sent_timestamp = element.sent_timestamp/1000
              let newDate = (ts,format)=>{
                if(!ts){return null}
                let ts_ms = ts * 1000;
                // initialize new Date object
                let date_ob = new Date(ts_ms);
                // year as 4 digits (YYYY)
                let year = date_ob.getFullYear(); 
                // month as 2 digits (MM)
                let month = ("0" + (date_ob.getMonth() + 1)).slice(-2); 
                // date as 2 digits (DD)
                let date = ("0" + date_ob.getDate()).slice(-2); 
                // hours as 2 digits (hh)
                let hours = ("0" + date_ob.getHours()).slice(-2); 
                // minutes as 2 digits (mm)
                let minutes = ("0" + date_ob.getMinutes()).slice(-2); 
                // seconds as 2 digits (ss)
                let seconds = ("0" + date_ob.getSeconds()).slice(-2);
  
                return date + "/" + month + "/" + year + " " + hours + ":" + minutes 
              }

              let icon = "rate_review"
              let status = "running.."
              if (element.submitted) {
                status = "submitted"
              }


              //get ward
              let centre_code = element.centre_code
              let centre = getters.getCentreByCode(centre_code)
              let centre_name = centre?centre.name:'--'
              
              //get ward
              let ward_code = element.ward_code
              let ward = getters.getWardByCode(ward_code)
              let ward_name = ward?ward.name:'--'

              //get constituency
              let constituency_code = element?element.constituency_code:null
              let constituency = getters.getConstituencyByCode(constituency_code)
              let constituency_name = constituency?constituency.name:'--'

              //get district
              let district_code = element?element.district_code:null
              let district = getters.getDistrictByCode(district_code)
              let district_name = district?district.name:'--'

              //get region
              let region_code = district?district.region_code:null
              let region = getters.getRegionByCode(region_code)
              let region_name = region?region.name:'--'

              //get Country 
              let country_code = region?region.country_code:null
              let country = getters.getCountryByCode(country_code)
              let country_name = country?country.name:'--'

              //get occurrence
              let occurrence_code = element.occurrence_code
              let occurrence = getters.getOccurrenceByCode(occurrence_code)
              let occurrence_name = occurrence?occurrence.name:'--'

              let questionnaires = getters.getQuestionnaireByOccurrenceCode(occurrence_code)
              let questionnaires_size = questionnaires?questionnaires.length:0
                  
              let newItem = {
                  ...element,
                  no:NUMBER,  
                  icon:icon,  
                  status:status,  
                  centre:centre,  
                  centre_name:centre_name,  
                  ward:ward,  
                  ward_name:ward_name,  
                  constituency:constituency,  
                  constituency_name:constituency_name,  
                  district:district,  
                  district_name:district_name,  
                  region:region,  
                  region_name:region_name,  
                  region_code:region_code,  
                  country:country,  
                  country_name:country_name,  
                  occurrence:occurrence,  
                  occurrence_name:occurrence_name,  
                  questionnaires:questionnaires,  
                  questionnaires_size:questionnaires_size,  
                  answered:'0/'+questionnaires_size,  
                  sent_at_:newDate(sent_timestamp), 
                  sent_at_date:toDate(sent_timestamp), 
                  sent_at_time:toTime(sent_timestamp), 
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      join_occurrences({ commit,getters},payload) {
        let response = {
          from:'join_occurrences',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){
              let sent_timestamp = element.sent_timestamp/1000
              let newDate = (ts,format)=>{
                if(!ts){return null}
                let ts_ms = ts * 1000;
                // initialize new Date object
                let date_ob = new Date(ts_ms);
                // year as 4 digits (YYYY)
                let year = date_ob.getFullYear(); 
                // month as 2 digits (MM)
                let month = ("0" + (date_ob.getMonth() + 1)).slice(-2); 
                // date as 2 digits (DD)
                let date = ("0" + date_ob.getDate()).slice(-2); 
                // hours as 2 digits (hh)
                let hours = ("0" + date_ob.getHours()).slice(-2); 
                // minutes as 2 digits (mm)
                let minutes = ("0" + date_ob.getMinutes()).slice(-2); 
                // seconds as 2 digits (ss)
                let seconds = ("0" + date_ob.getSeconds()).slice(-2);
  
                return date + "/" + month + "/" + year + " " + hours + ":" + minutes 
              }

              let icon = "rate_review"
              let status = "running.." 
               

              let code = element.code
              let questionnaires = getters.getQuestionnaireByOccurrenceCode(code)
              let questionnaires_size = questionnaires?questionnaires.length:0
              
              let web_reports = getters.getWebReportsByOccurrenceCode(code)
              let web_reports_size = web_reports?web_reports.length:0

              let mobile_reports = getters.getMobileReportsByOccurrenceCode(code)
              let mobile_reports_size = mobile_reports?mobile_reports.length:0
                  
              let newItem = {
                  ...element,
                  no:NUMBER,  
                  icon:icon,   
                  icon: element.disabled?'mdi-checkbox-blank-outline':'mdi-checkbox-marked',
                  questionnaires:questionnaires,  
                  questionnaires_size:questionnaires_size, 
                  web_reports:web_reports,  
                  web_reports_size:web_reports_size,  
                  mobile_reports:mobile_reports,  
                  mobile_reports_size:mobile_reports_size,  
                  answered:'0/'+questionnaires_size,  
                  sent_at_:newDate(sent_timestamp), 
                  sent_at_date:toDate(sent_timestamp), 
                  sent_at_time:toTime(sent_timestamp), 
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      

      join_supplier({ commit,getters},payload) {
        let response = {
          from:'join_supplier',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){
              let supplier_category_code = element.supplier_category_code
              let supplier_category = getters.getSupplierCategoryByCode(supplier_category_code)
              let supplier_category_name = supplier_category?supplier_category.name:'--'
                  
              let newItem = {
                  ...element,
                  no:NUMBER, 
                  supplier_category:supplier_category,
                  supplier_category_name:supplier_category_name, 
                  name:TEXT_UP11(element.name),
                  created_at_:toDateTime(element.created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              } 
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      
      join_others({ commit,getters},payload) {
        let response = {
          from:'join_others',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try {  
            let element = payload?payload.data:null    
            let NUMBER = payload?payload.NUMBER:1   
            if(element){ 
              //teller
              let uid = element.created_uid
              let user = getters.getUserByUid(uid) 
              let user_name = user?user.surname+''+user.names:'--' 
              
              
              let newItem = {
                  ...element,
                  no:NUMBER,   
                  user:user,
                  user_name:user_name,  
                  created_at_:toDateTime(element.created_at), 
                  created_at_date:toDate(element.created_at), 
                  created_at_time:toTime(element.created_at), 
                  local_created_at_:toDateTime(element.local_created_at), 
                  local_created_at_date:toDate(element.local_created_at), 
                  local_created_at_time:toTime(element.local_created_at), 
                  created_at_server_:toDateTime(element.created_at_server),
                  created_at_server_date:toDate(element.created_at_server),
                  created_at_server_time:toTime(element.created_at_server),
                  updated_at_:toDateTime(element.updated_at), 
                  updated_at_server_:toDateTime(element.updated_at_server), 
              }
              resolve({
                success:true, 
                data:newItem
              })
            }else{
              resolve({
                success:false, 
                data:null,
                error:'no data',
              })
              return
            }  
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      }, 
    }
}